<template>
  <div
    class="second-page-root"
    ref="navBox"
    :class="{ 'a-fadeinB': changeClassName }"
  >
    <div class="content">
      <div class="title-box">
        <img src="../../assets/displayPage/quotation-mark.png" alt="" />
        楼域介绍
      </div>
      <div class="content-box">
        <div class="left-content">
          <div class="font">
            楼域是北京优动空间科技管理有限公司旗下品牌，由北京云飒科技有限公司负责运营
          </div>
          <br />
          <div class="font">
            楼域业主直租平台是专为楼宇业主与租客搭建的线上租赁服务生态系统，致力于打破传统租赁市场中介环节，实现业主与租客直接对接，提升租售效率，降低交易成本，平台以创新技术为驱动，以用户体验为核心，提供一站式、透明化、安全便捷的房屋租赁解决方案，构建起一个公平、公正、高效的房地产直租市场。
          </div>
          <br />
          <div class="font">
            平台主要特点:允许房东和租客直接对接，减少了中间环节，这样既降低了租客的成本，也提高了租房效率。平台上的房源都是真实的，确保租客能够找到可靠的租赁信息。提供包括写字楼、商铺、仓库、厂房等多种类型的业主直租房源，满足不同租客的需求。这种模式有助于推动租房市场的透明化和效率化，同时也促进了房地产市场的健康有序发展。
          </div>
          <br />
          <div class="font">
            此外，楼域还将积极拓展业务领域，除了写字楼，商铺、厂房、仓库租赁服务外，楼域还将进一步拓展住宅等领域。
          </div>
        </div>
        <div class="right-content">
          <img
            src="../../assets/displayPage/second.png"
            alt=""
            class="right-content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      observer: null,
      changeClassName: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.setObserver();
  },
  beforeDestroy() {
    this.disconnectObservers();
  },
  methods: {
    disconnectObservers() {
      if (this.observer) {
        this.observer.unobserve(this.$refs.navBox); //解绑元素
        this.observer.disconnect(); //停止监听
      }
    },
    setObserver() {
      this.observer = new IntersectionObserver((entries) => {
        // this.timeOut = setTimeout(() => {
        this.changeClassName = entries[0].isIntersecting;
        // clearTimeout(this.timeOut)
        // this.timeOut = null
        // }, 500)
      });
      this.observer.observe(this.$refs.navBox);
    },
  },
};
</script>

<style lang="scss" scoped>
.second-page-root {
  width: 100%;
  height: 597px;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 16%, #f7faff 100%);
  .content {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    .title-box {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 24px;
      color: #121218;
      line-height: 24px;
      padding-top: 74px;
      img {
        width: 61.5px;
        height: 49px;
        margin-right: 15px;
      }
    }
    .content-box {
      margin: 40px 0 0 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(1200px - 44px);
      .font {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        font-size: 16px;
        color: #3d3d3d;
        line-height: 28px;
      }
      .left-content {
        margin-right: 64px;
      }
      .right-content {
        width: 495px;
        height: 356px;
      }
    }
  }
}
.a-fadeinB {
  animation: fadeinB 1s ease-out backwards;
}
@keyframes fadeinB {
  0% {
    opacity: 0;
    transform: translate3d(0, 10%, 0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    transform: translate3d(0, 0, 0);
  }
}
</style>
